import React from 'react';
import MoneyPersonalityQuiz from './MoneyPersonalityQuiz';

function App() {
  return <MoneyPersonalityQuiz />;
}

export default App;